<template>
  <div class="tickBox">
    <el-row>
      <el-col :span="24" class="tickMid">
        <el-col :span="12" class="mma"> FEDEX单号查询 </el-col>
        <el-col :span="12" class="rigrig">
          <el-upload
            class="upload-demo"
            :action="handleExcel()"
            :limit="10"
            accept=".xlsx"
            :on-success="handsuccess"
            :show-file-list = "false"
          >
            <el-button type="primary">导入FEDEX单号</el-button>
          </el-upload>
          <!-- <el-button type="primary" plain class="butsTwo" @click="handleExcel"
            >导入FEDEX单号</el-button
          > -->
        </el-col>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" class="formBox">
        <span class="spanfont"> 订单编号 </span>
        <div class="radioBox">
          <el-input v-model="codeValue" placeholder="请输入订单编号"></el-input>
        </div>
        <el-radio-group
          v-model="radio3"
          size="small"
          @change="handleRadioChange"
        >
          <el-radio-button label="">全部</el-radio-button>
          <el-radio-button label="0">未使用</el-radio-button>
          <el-radio-button label="1">已使用</el-radio-button>
        </el-radio-group>
        <div class="radioBox">
          <el-button type="primary" plain class="butsOne" @click="handleReset"
            >重置</el-button
          >
          <el-button type="primary" class="butsTwo" @click="handleSearch"
            >查询</el-button
          >
        </div>
      </el-col>
      <el-col :span="24" v-loading="loading" class="tabBox">
        <el-table :data="tableData" border stripe style="width: 100%">
          <el-table-column prop="xh" label="序号"> </el-table-column>
          <el-table-column prop="code" label="订单编号">
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                :content="scope.row.code"
                placement="top"
              >
                <span>{{ scope.row.code }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="订单状态">
            <template slot-scope="scope">
              <div v-if="scope.row.status == 0">未使用</div>
              <div v-if="scope.row.status == 1">已使用</div>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="24" class="pageBox">
        <div class="pagination">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page.sync="nowpage"
            layout="prev, pager, next"
            prev-text="上一页"
            next-text="下一页"
            :page-size="pagelist"
            :total="this.totalPage"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Clipboard from "clipboard";
import Vue from "vue";
import axios from "axios";
export default {
  data() {
    return {
      nowpage: 1,
      pagelist: 10,
      loading: true,
      codeValue: "",
      input: "",
      tableData: [],
      total: 100,
      pageSize: "1",
      comValue: "",
      status: "",
      totalPage: 0,
      radio3: "",
    };
  },
  mounted() {
    this.handleAjax();
  },
  methods: {
    handleExcel() {
      return "https://api.with-ex.net/fedex/importfedex";
    },
    handsuccess() {
      this.$message({
        message: "恭喜你，上传成功",
        type: "success",
      });
      this.handleAjax();
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },

    handleCurrentChange(val) {
      this.nowpage = val;
      this.handleAjax();
    },

    handleAjax() {
      this.loading = true;
      let bizContent = {};
      bizContent.currentPage = this.nowpage;
      bizContent.pageSize = "10";
      bizContent.code = this.codeValue;
      bizContent.status = this.status;
      this.ajax
        .post(this.versatile.withurl + "/fedex/fedexList", { bizContent })
        .then((result) => {
          // console.log(result)
          if (result.data.status == "0000") {
            console.log("resule.data", result.data);
            let arr = result.data.data.data.responseList;
            this.totalPage = result.data.data.data.totalNum;
            console.log(result.data.data.data.data);
            arr.forEach((item) => {
              console.log(item);
            });
            arr.map((it, index) => {
              it.xh = index + 1;
            });
            this.tableData = arr;
            this.total = result.data.data.data.totalNum;
            this.loading = false;
          } else {
            this.$message(result.data.data.message);
          }
        });
    },
    handleReset() {
      this.codeValue = "";
      this.radio3 = " ";
    },
    handleSearch() {
      console.log(this.comValue, this.codeValue, this.radio3);
      this.status = this.radio3;
      this.handleAjax();
    },
    handleRadioChange(val) {
      console.log("val", val);
      this.status = val;
      this.handleAjax();
    },
  },
};
</script>

<style  scoped>
.other {
  position: absolute;
}
.tickBox {
  margin-left: 20px;
}
.tickMid {
  margin-top: 10px;
  width: 100%;
  background: #fff;
  height: 55px;
  line-height: 50px;
  text-align: left;
  padding: 10px 15px;
}
.mma {
  font-size: 24px;
  padding-left: 10px;
}
.rigrig {
  text-align: right;
}
.formBox {
  padding: 20px 5px 20px 15px;
  background: #fff;
  /* border: 2px solid #eee;
    box-shadow: 2px 2px 4px #eee; */
  /* margin: 10px 0; */
}
.alls {
  margin-top: 20px;
}
.radioBox {
  height: 40px;
  line-height: 40px;
  margin-right: 10px;
  display: inline-block;
  margin-bottom: 10px;
}
.radioBox >>> .el-input__inner {
  width: 224px;
}
.selBox {
  margin-right: 20px;
}

.butsOne {
  width: 74px;
  height: 30px;
  padding: 0;
}
.butsTwo {
  width: 74px;
  height: 30px;
  padding: 0;
  margin-right: 20px;
}
.spanfont {
  height: 40px;
  width: 70px;
  display: inline-block;
  text-align: right;
  line-height: 40px;
  margin-right: 5px;
  margin-left: 5px;
  color: #333333;
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 10px;
}
.pickBox > .el-input__inner {
  width: 305px;
}
.tabBox {
  /* min-height: 720px; */
  background: #fff;
  padding: 0 20px;
}
/* .tabBox>>>.el-table__empty-text{
    min-height: 360px;
    line-height: 360px;
} */
.tabBox >>> .el-table__body-wrapper {
  min-height: 710px;
  overflow-y: auto;
}
.tabBox >>> .el-table__body-wrapper::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
.tabBox >>> .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #ddd;
  border-radius: 3px;
}
.pageBox {
  text-align: center;
  margin: 20px 0;
}
#alterOrder .demo-input-suffix {
  width: 30%;
}
</style>


// WEBPACK FOOTER //
// src/PAGE/bankAcceptance/fedex.vue